import m, { Vnode, VnodeDOM } from 'mithril';
import FilterTagsDropdown, { TTagOption } from '../FilterTagsDropdown';

export default class FilterTagsDropdownView {

    private itemsContainer: HTMLElement | null = null;

    constructor(
        private readonly host: FilterTagsDropdown,
    ) { }

    public view(): Vnode[] {
        const nodes: Vnode[] = [];

        if (this.host.options.length === 0) {
            nodes.push(m('div.filter-select-dropdown-empty', { key: '__empty' }, this.host.translator.translate('no_tags_available')));
            return nodes;
        }

        if (this.host.showSearch()) {
            nodes.push(this.search());
        }

        const filtered = this.host.getFilteredOptions();

        if (filtered.length === 0) {
            nodes.push(m('div.filter-select-dropdown-empty', { key: '__empty' }, this.host.translator.translate('no_item_found')));
        } else {
            nodes.push(m('div.filter-select-dropdown-items', {
                key: '__items',
                oncreate: (vnode: VnodeDOM) => {
                    this.itemsContainer = vnode.dom as HTMLElement;
                },
                onremove: () => {
                    this.itemsContainer = null;
                },
            }, filtered.map((o, i) => this.item(o, i))));
        }

        return nodes;
    }

    private search(): Vnode {
        return m('div.filter-select-dropdown-search', {
            key: '__search',
        }, [
            m('input.form-control', {
                type: 'text',
                value: this.host.searchQuery,
                oninput: (e: InputEvent) => {
                    this.host.setSearchQuery((e.target as HTMLInputElement).value);
                },
                onkeydown: (e: KeyboardEvent) => this.onSearchKeydown(e),
            }),
        ]);
    }

    private item(option: TTagOption, index: number): Vnode {
        const tagClasses = ['tag', 'text-decoration-none'];
        if (option.color) {
            tagClasses.push(`tag-color-${option.color}`);
        }

        const highlighted = index === this.host.highlightedIndex;
        const classes = [
            'filter-select-dropdown-item',
            option.selected ? 'is-selected' : '',
            highlighted ? 'is-highlighted' : '',
        ].filter(Boolean).join('.');

        return m(`button.${classes}`, {
            type: 'button',
            key: option.value,
            onclick: (e: MouseEvent) => {
                e.preventDefault();
                this.host.toggle(option);
            },
            onupdate: (vnode: VnodeDOM) => {
                if (highlighted) {
                    (vnode.dom as HTMLElement).scrollIntoView({ block: 'nearest' });
                }
            },
        }, [
            m('span.' + tagClasses.join('.'), [
                m('span.tag-name', option.label),
            ]),
            option.selected
                ? m('i.bi.bi-check2.filter-select-dropdown-item-check.d-flex')
                : null,
        ]);
    }

    private onSearchKeydown(e: KeyboardEvent): void {
        if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
            if (this.host.getFilteredOptions().length === 0) {
                return;
            }
            e.preventDefault();
            this.host.moveHighlight(e.key === 'ArrowDown' ? 1 : -1);
            return;
        }
        if (e.key === 'Enter') {
            e.preventDefault();
        }
        if ((e.key === 'Enter' || e.key === ' ') && this.host.highlightedIndex >= 0) {
            e.preventDefault();
            const button = this.itemsContainer?.querySelectorAll<HTMLButtonElement>('.filter-select-dropdown-item')[this.host.highlightedIndex];
            button?.click();
        }
    }
}
